type AnyRow = Record<string, any>;

function pickTime(row: AnyRow): string | null {
  const v =
    row.ts ??
    row.t ??
    row.time ??
    row.datetime ??
    row.bucket ??
    row.bucketStart ??
    row.start ??
    row.occurredAt ??
    row.createdAt;
  if (!v) return null;
  // se è numero epoch sec/ms
  if (typeof v === "number") {
    const ms = v > 10_000_000_000 ? v : v * 1000; // heuristic
    return new Date(ms).toISOString();
  }
  // string ISO
  if (typeof v === "string") return v;
  return null;
}

function pickValue(row: AnyRow): number | null {
  const v =
    row.value ??
    row.v ??
    row.val ??
    row.avg ??
    row.mean ??
    row.y ??
    row.reading;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}

export function normalizeTelemetryResponse(payload: any): Array<{ t: string; value: number }> {
  const arr: any[] =
    Array.isArray(payload) ? payload :
    Array.isArray(payload?.points) ? payload.points :
    Array.isArray(payload?.data) ? payload.data :
    Array.isArray(payload?.items) ? payload.items :
    [];

  const out: Array<{ t: string; value: number }> = [];

  for (const row of arr) {
    if (!row || typeof row !== "object") continue;
    const t = pickTime(row as AnyRow);
    const value = pickValue(row as AnyRow);
    if (!t || value === null) continue;
    out.push({ t, value });
  }

  // ordina per tempo crescente se possibile
  out.sort((a, b) => (a.t < b.t ? -1 : a.t > b.t ? 1 : 0));
  return out;
}